import queryString from 'query-string'

export function getEncodedString(queryObj: Record<string, any>): string {
    const queryStringEncoded = queryString.stringify(queryObj)

    return queryStringEncoded
}
